// Suspended Account Dialog - Only for manually suspended accounts (no download access)
import { createPortal } from 'react-dom';
import { AlertTriangle, LogOut } from 'lucide-react';
import { useAuthStore } from '@stores/authStore';

interface SuspendedDialogProps {
  isOpen: boolean;
}

export const SuspendedDialog = ({ isOpen }: SuspendedDialogProps) => {
  const { logout } = useAuthStore();

  if (!isOpen) return null;

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm">
      <div className="bg-dark border border-white/10 rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 rounded-full bg-red-500/20 flex items-center justify-center flex-shrink-0">
            <AlertTriangle className="w-6 h-6 text-red-400" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-white">Account Suspended</h2>
            <p className="text-white/60 text-sm mt-1">Your account has been temporarily suspended.</p>
          </div>
        </div>

        <div className="space-y-4 mb-6">
          <p className="text-white/80 text-sm leading-relaxed">
            Your account has been suspended. Please contact info@fyle-cloud.com so we can review and reactivate your account.
          </p>
        </div>

        <button
          onClick={handleLogout}
          className="w-full px-4 py-3 bg-red-500 hover:bg-red-600 text-white rounded-lg font-medium transition-all flex items-center justify-center gap-2"
        >
          <LogOut className="w-4 h-4" />
          Logout
        </button>
      </div>
    </div>,
    document.body
  );
};

